import React, { createContext, useContext, useReducer } from 'react';
import { Outlet } from 'react-router-dom';

const FavoriteMarketContext = createContext();
const FavoriteMarketsDispatchContext = createContext();

export function useFavoriteMarkets() {
    return useContext(FavoriteMarketContext);
}

export function useFavoriteMarketsDispatch() {
    return useContext(FavoriteMarketsDispatchContext);
}

export function getFavoriteMarketsFromLS(key) {
    const saved = localStorage.getItem(key);
    if (saved == null) {
        return {};
    } else {
        const favorites = JSON.parse(saved);

        let maxTs = new Date();
        maxTs.setMinutes(maxTs.getHours() - 12);
        maxTs = +maxTs;
        const toDelete = new Set();
        Object.keys(favorites).forEach(key => {
            const ts = favorites[key]
            if (ts < maxTs) {
                toDelete.add(key);
            }
        });

        if (toDelete.size > 0) {
            toDelete.forEach(id => delete favorites[id]);
        }

        return favorites;
    }
}

function saveFavoriteMarketsToLS(key, favorites) {
    if (Object.values(favorites).length > 0) {
        localStorage.setItem(key, JSON.stringify(favorites));
    } else {
        localStorage.removeItem(key);
    }
}

function favoritesReducer(favorites, action) {
    switch (action.type) {
        case 'toggle': {
            if (favorites[action.id] == null) {
                favorites[action.id] = +new Date();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                delete favorites[action.id];
            }
            saveFavoriteMarketsToLS('xs_favorite_markets', favorites);
            return {...favorites};
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

export default function FavoriteMarketsProvider() {
    const [favorites, dispatch] = useReducer(
        favoritesReducer,
        getFavoriteMarketsFromLS('xs_favorite_markets')
    );

    return (
        <FavoriteMarketContext.Provider value={favorites}>
            <FavoriteMarketsDispatchContext.Provider value={dispatch}>
                <Outlet />
            </FavoriteMarketsDispatchContext.Provider>
        </FavoriteMarketContext.Provider>
    );
}
